import swal from "sweetalert";
import {
  CREATE_ORGAN_FAIL,
  CREATE_ORGAN_REQUEST,
  CREATE_ORGAN_SUCCESS,
  CREATE_SURGERY_FAIL,
  CREATE_SURGERY_REQUEST,
  CREATE_SURGERY_SUCCESS,
  CREATE_TYPE_SURGERY_FAIL,
  CREATE_TYPE_SURGERY_REQUEST,
  CREATE_TYPE_SURGERY_SUCCESS,
  FETCH_ORGAN_FAIL,
  FETCH_ORGAN_REQUEST,
  FETCH_ORGAN_SUCCESS,
  FETCH_SURGERY_FAIL,
  FETCH_SURGERY_REQUEST,
  FETCH_SURGERY_SUCCESS,
  FETCH_TYPE_SURGERY_FAIL,
  FETCH_TYPE_SURGERY_REQUEST,
  FETCH_TYPE_SURGERY_SUCCESS,
  GET_SURGERY_BY_IDS_FAIL,
  GET_SURGERY_BY_IDS_REQUEST,
  GET_SURGERY_BY_IDS_SUCCESS,
  SHOW_ORGAN_FAIL,
  SHOW_ORGAN_REQUEST,
  SHOW_ORGAN_SUCCESS,
  SHOW_TYPE_SURGERY_FAIL,
  SHOW_TYPE_SURGERY_REQUEST,
  SHOW_TYPE_SURGERY_SUCCESS,
  UPDATE_ORGAN_FAIL,
  UPDATE_ORGAN_REQUEST,
  UPDATE_ORGAN_SUCCESS,
  UPDATE_SURGERY_FAIL,
  UPDATE_SURGERY_REQUEST,
  UPDATE_SURGERY_SUCCESS,
  UPDATE_TYPE_SURGERY_FAIL,
  UPDATE_TYPE_SURGERY_REQUEST,
  UPDATE_TYPE_SURGERY_SUCCESS,
} from "../../ActionType/SurgeryType/SurgeryType";
import { api } from "../../Api/api";
import { getToken } from "../login";

export const getSurgeryAction = (name) => async (dispatch) => {
  const config = {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
    params: {
      name,
    },
  };

  dispatch({
    type: FETCH_SURGERY_REQUEST,
    payload: [],
  });
  try {
    const response = await api.get("surgery", config);
    const { status, data } = response;
    if (status == 200) {
      dispatch({
        type: FETCH_SURGERY_SUCCESS,
        payload: data,
      });
    }
  } catch (error) {
    dispatch({
      type: FETCH_SURGERY_FAIL,
      payload: [],
    });
  }
};

export const createSurgeryAction = (name) => async (dispatch) => {
  const config = {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  };

  dispatch({
    type: CREATE_SURGERY_REQUEST,
    payload: [],
  });
  try {
    const response = await api.post("surgery/create", { name }, config);
    const { status, data } = response;
    if (status == 201) {
      dispatch(getSurgeryAction());
      dispatch(getSurgeryAction());
      swal({
        title: "Good job!",
        text: "Surgery  was saved Successfully !",
        icon: "success",
        button: "OK",
        timer: 2000,
      });
      dispatch({
        type: CREATE_SURGERY_SUCCESS,
        payload: data,
      });
    }
  } catch (error) {
    dispatch({
      type: CREATE_SURGERY_FAIL,
      payload: [],
      error: error.response.data,
    });
  }
};

export const updateSurgeryAction = (surgery_id, name) => async (dispatch) => {
  const config = {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  };

  dispatch({
    type: UPDATE_SURGERY_REQUEST,
    payload: [],
  });
  try {
    const response = await api.put(
      `surgery/update/${surgery_id}`,
      { name },
      config
    );
    const { status, data } = response;
    if (status == 200) {
      dispatch(getSurgeryAction());
      dispatch(getSurgeryAction());
      swal({
        title: "Good job!",
        text: "Surgery  was Updated Successfully !",
        icon: "success",
        button: "OK",
        timer: 2000,
      });
      dispatch({
        type: UPDATE_SURGERY_SUCCESS,
        payload: data,
      });
    }
  } catch (error) {
    dispatch({
      type: UPDATE_SURGERY_FAIL,
      payload: [],
    });
  }
};

export const createTypeSurgeryAction =
  (surgery_id, en_name) => async (dispatch) => {
    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    };

    dispatch({
      type: CREATE_TYPE_SURGERY_REQUEST,
      payload: [],
    });
    try {
      const response = await api.post(
        "typeSurgery/create",
        { surgery_id, name:en_name },
        config
      );
      const { status, data } = response;

      if (status == 201) {
        dispatch(getTypeSurgeryAction());
        dispatch(getTypeSurgeryAction());
        swal({
          title: "Good job!",
          text: "Surgery  was saved Successfully !",
          icon: "success",
          button: "OK",
          timer: 2000,
        });
        console.log("data : ", data);
        dispatch({
          type: CREATE_TYPE_SURGERY_SUCCESS,
          payload: data,
        });
      }
    } catch (error) {
      if (error.response.status == 422) {
        dispatch({
          type: CREATE_TYPE_SURGERY_FAIL,
          payload: [],
          error: error.response.data.errors,
        });
      }
    }
  };

export const getTypeSurgeryAction = (inputValue) => async (dispatch) => {
  let krdName = null;
  let enName = null;
  if (inputValue) {
    krdName = inputValue.krdName || null;
    enName = inputValue.enName || null;
  }

  const config = {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
    params: {
      krdName,
      enName,
    },
  };
  dispatch({
    type: FETCH_TYPE_SURGERY_REQUEST,
    payload: [],
  });
  try {
    const response = await api.get("typeSurgery", config);
    const { status, data } = response;
    if (status == 200) {
      dispatch({
        type: FETCH_TYPE_SURGERY_SUCCESS,
        payload: data,
      });
    }
  } catch (error) {
    if (error.response.status == 422) {
      dispatch({
        type: FETCH_TYPE_SURGERY_FAIL,
        payload: [],
        error: error.response.data.errors,
      });
    }
  }
};

export const showTypeSurgeryAction = (ids) => async (dispatch) => {
  let surgery_ids = [];
  ids.map((id) => {
    surgery_ids.push(id.value);
  });
  const config = {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
    params: {
      id: surgery_ids,
    },
  };

  // console.log(surgery_ids)
  dispatch({
    type: SHOW_TYPE_SURGERY_REQUEST,
    payload: [],
  });
  try {
    const response = await api.get(`typeSurgery/show`, config);
    const { status, data } = response;
    console.log(response);
    if (status == 200) {
      dispatch({
        type: SHOW_TYPE_SURGERY_SUCCESS,
        payload: data,
      });
    }
  } catch (error) {
    if (error.response.status == 422) {
      dispatch({
        type: SHOW_TYPE_SURGERY_FAIL,
        payload: [],
        error: error.response.data.errors,
      });
    }
  }
};

export const updateTypeSurgeryAction =
  (id, en_name, ku_name) => async (dispatch) => {
    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    };

    dispatch({
      type: UPDATE_TYPE_SURGERY_REQUEST,
      payload: [],
    });
    try {
      const response = await api.put(
        `typeSurgery/update/${id}`,
        { name:en_name, ku_name },
        config
      );
      const { status, data } = response;

      if (status == 200) {
        dispatch(getTypeSurgeryAction());
        dispatch(getTypeSurgeryAction());
    
        swal({
          title: "Good job!",
          text: "Type Surgery  was update Successfully !",
          icon: "success",
          button: "OK",
          timer: 2000,
        });

        dispatch({
          type: UPDATE_TYPE_SURGERY_SUCCESS,
          payload: data,
        });
      }
    } catch (error) {
      if (error.response.status == 422) {
        dispatch({
          type: UPDATE_TYPE_SURGERY_FAIL,
          payload: [],
          error: error.response.data.errors,
        });
      }
    }
  };

export const createOrganAction =
  (type_surgery_id, en_name,ku_name) => async (dispatch) => {
    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    };

    dispatch({
      type: CREATE_ORGAN_REQUEST,
      payload: [],
    });
    try {
      const response = await api.post(
        "organ/create",
        { type_surgery_id, en_name,ku_name },
        config
      );
      const { status, data } = response;

      if (status == 201) {
        swal({
          title: "Good job!",
          text: "Organ  was saved Successfully !",
          icon: "success",
          button: "OK",
          timer: 2000,
        });

        dispatch({
          type: CREATE_ORGAN_SUCCESS,
          payload: data,
        });
      }
    } catch (error) {
      console.log(error);
      if (error.response.status == 422) {
        dispatch({
          type: CREATE_ORGAN_FAIL,
          payload: [],
          error: error.response.data.errors,
        });
      }
    }
  };

export const getSurgeryByIdsAction =
  (surgery_id, type_surgery_id) => async (dispatch) => {
    let surgeryIdList = [];
    surgery_id.map((surgery) => {
      surgeryIdList.push(surgery.value);
    });
    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
      params: {
        surgery_id: surgeryIdList,
        type_surgery_id,
      },
    };

    dispatch({
      type: GET_SURGERY_BY_IDS_REQUEST,
      payload: [],
    });
    try {
      const response = await api.get("organ/getSurgeryByIds", config);
      const { status, data } = response;

      if (status == 200) {
        console.log(response);
        dispatch({
          type: GET_SURGERY_BY_IDS_SUCCESS,
          payload: data,
        });
      }
    } catch (error) {
      if (error.response.status == 422) {
        dispatch({
          type: GET_SURGERY_BY_IDS_FAIL,
          payload: [],
          error: error.response.data.errors,
        });
      }
    }
  };

export const getOrganAction = (name) => async (dispatch) => {
  const config = {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
    params: {
      name,
    },
  };

  dispatch({
    type: FETCH_ORGAN_REQUEST,
    payload: [],
  });
  try {
    const response = await api.get("organ", config);
    const { status, data } = response;

    if (status == 200) {
      dispatch({
        type: FETCH_ORGAN_SUCCESS,
        payload: data,
      });
    }
  } catch (error) {
    if (error.response.status == 422) {
      dispatch({
        type: FETCH_ORGAN_FAIL,
        payload: [],
        error: error.response.data.errors,
      });
    }
  }
};

export const updateOrganAction = (id, en_name,ku_name,typeSurgeryId) => async (dispatch) => {
  const config = {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  };

  dispatch({
    type: UPDATE_ORGAN_REQUEST,
    payload: [],
  });
  try {
    const response = await api.put(`organ/update/${id}`, {type_surgery_id:typeSurgeryId, en_name,ku_name }, config);
    const { status, data } = response;

    if (status == 200) {
      dispatch(getOrganAction());
      dispatch(getOrganAction());
      swal({
        title: "Good job!",
        text: "Organ  was Update Successfully !",
        icon: "success",
        button: "OK",
        timer: 2000,
      });
      dispatch({
        type: UPDATE_ORGAN_SUCCESS,
        payload: data,
      });
    }
  } catch (error) {
    // console.log(error);
    if (error.response.status == 422) {
      dispatch({
        type: UPDATE_ORGAN_FAIL,
        payload: [],
        error: error.response.data.errors,
      });
    }
  }
};

export const showOrganAction = (ids) => async (dispatch) => {
  let surgery_ids = [];
  ids.map((id) => {
    surgery_ids.push(id.value);
  });
  const config = {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
    params: {
      id: surgery_ids,
    },
  };

  dispatch({
    type: SHOW_ORGAN_REQUEST,
    payload: [],
  });
  try {
    const response = await api.get(`organ/show`, config);
    const { status, data } = response;

    if (status == 200) {
      dispatch({
        type: SHOW_ORGAN_SUCCESS,
        payload: data,
      });
    }
  } catch (error) {
    if (error.response.status == 422) {
      dispatch({
        type: SHOW_ORGAN_FAIL,
        payload: [],
        error: error.response.data.errors,
      });
    }
  }
};
